var _style, _polygon, _path, _polygon2, _path2, _polygon3, _polygon4, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 548.2 294.8",
    style: {
      enableBackground: "new 0 0 548.2 294.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "55,102.8 90.8,102.8 90.8,94.5 9.2,94.5 9.2,102.8 45,102.8 49.9,148.8 44.6,200.3 55.4,200.3  50.2,148.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.4,94.5h-10.9l-23.3,66.6L90,200.3h12.1l3.8-34.9h58.8l4.7,34.9h12.4l-18.6-39.1L141.4,94.5z M109.2,156.9 l26.4-50.2l25.7,50.2H109.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "274.3,156 245.5,94.5 233.1,94.5 269.7,147.4 269.7,200.3 278.8,200.3 278.8,147.4 315.4,94.5  303.3,94.5 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369,94.5h-10.9l-23.3,66.6l-17.2,39.1h12.1l3.8-34.9h58.8l4.7,34.9h12.4l-18.6-39.1L369,94.5z M336.8,156.9 l26.4-50.2l25.7,50.2H336.8z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "503.9,94.5 491.6,94.5 435.2,149.2 440.5,94.5 429.6,94.5 435,155 429.6,200.3 440.5,200.3  434.9,160.2 451.1,144.8 494.6,200.3 506.4,200.3 457.7,138.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "207.6,130.4 212.9,94.5 202,94.5 207.3,130.4 202,164.4 207.5,200.3 212.9,164.4 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "533.7,164.4 539,200.3 528.1,200.3 533.4,164.4 528.1,130.4 533.6,94.5 539,130.4 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.4c7fbd7200ef5d27c943858b8fa970bd.svg";
export { ForwardRef as ReactComponent };